import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs';

import { SiteSelectItemDto } from '@app/api/models';
import {
  ContainerSortimentsService,
  PackageSortimentsService,
} from '@app/api/services';

import { ProductPackagingUnitActions } from './product-packaging-unit.slice';

@Injectable({ providedIn: 'root' })
export class ProductPackagingUnitsEffects {
  loadStandalonePackagingUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductPackagingUnitActions.loadStandalonePackagingUnits.trigger),
      switchMap((action) => {
        if (action.withDepositFee) {
          return this.containerSortimentsService
            .getContainerSelectItemsFromSortiment({
              subType: action.packingMethodSubType,
            })
            .pipe(
              map((res: Array<SiteSelectItemDto>) =>
                ProductPackagingUnitActions.loadStandalonePackagingUnits.success(
                  {
                    packagingUnits: res,
                  }
                )
              )
            );
        } else {
          return this.packageSortimentsService
            .getPackageSelectItemsFromSortiment({
              subType: action.packingMethodSubType,
            })
            .pipe(
              map((res: Array<SiteSelectItemDto>) =>
                ProductPackagingUnitActions.loadStandalonePackagingUnits.success(
                  {
                    packagingUnits: res,
                  }
                )
              )
            );
        }
      })
    )
  );

  loadCollectionPackagingUnits$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductPackagingUnitActions.loadCollectionPackagingUnits.trigger),
      switchMap((action) => {
        if (action.withDepositFee) {
          return this.containerSortimentsService
            .getContainerSelectItemsFromSortiment({
              subType: action.packingMethodSubType,
            })
            .pipe(
              map((res: Array<SiteSelectItemDto>) =>
                ProductPackagingUnitActions.loadCollectionPackagingUnits.success(
                  {
                    packagingUnits: res,
                  }
                )
              )
            );
        } else {
          return this.packageSortimentsService
            .getPackageSelectItemsFromSortiment({
              subType: action.packingMethodSubType,
            })
            .pipe(
              map((res: Array<SiteSelectItemDto>) =>
                ProductPackagingUnitActions.loadCollectionPackagingUnits.success(
                  {
                    packagingUnits: res,
                  }
                )
              )
            );
        }
      })
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly containerSortimentsService: ContainerSortimentsService,
    private readonly packageSortimentsService: PackageSortimentsService
  ) {}
}
